export interface UrlParams {
  organization?: string;
  locale?: string;
  type?: string;
  uuid?: string;
  projectId?: string;
  preview?: boolean;
  previewLink?: boolean;
  surveyComplete?: boolean;
  code?: string;
  sessionId?: string;
  version?: string;
}

export enum QueryParam {
  IGNORE_SYNC_TABS = 'ignoreSyncTabs',
  IS_LIVE_PRESENTER = 'presenter',
  PREVIEW_LINK = 'previewLink',
}
